var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"638553ed02fade8dadfc25c403bfc6f539996332"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["elo-cabinets@elopage"]={id:"638553ed02fade8dadfc25c403bfc6f539996332"};
      